import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import ReconciliationPageUI from './ReconciliationPageUI.js'

class ReconciliationPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      txnList: null,
      bankTxnList: null,
      reconcileSubmitted: false,
      copyToClipboardText: null,
      uploadMode: false,
      otherUploadMode: false,
      selectedAppTxnId: null,
      selectedBankTxnId: null,
      nachReconciliationMode: false,
      iciciReconciliationMode: false
    }
  }

  render() {
    return (
      <ReconciliationPageUI
        context={this.props.context}
        accountNumber={this.props.match.params.accountNumber}
        txnList={this.state.txnList}
        bankTxnList={this.state.bankTxnList}
        on441Click={this.on441Click}
        onRefreshClick={this.onRefreshClick}
        //
        reconcileSubmitted={this.state.reconcileSubmitted}
        onReconcileClick={this.onReconcileClick}
        successMsg={this.state.successMsg}
        errorList={this.state.errorList}
        //
        uploadMode={this.state.uploadMode}
        onUploadClick={() => { this.setState({ uploadMode: true }) }}
        onCancelUploadClick={() => { this.setState({ uploadMode: false }) }}
        signedUrlApi={`/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankStatements/fileUploadSignedUrl`}
        onUpload={this.onUpload}
        //
        otherUploadMode={this.state.otherUploadMode}
        onOtherUploadClick={() => { this.setState({ otherUploadMode: true }) }}
        onOtherCancelUploadClick={() => { this.setState({ otherUploadMode: false }) }}
        onOtherUpload={this.onOtherUpload}
        //
        copyToClipboardText={this.state.copyToClipboardText}
        onCopyToClipboard={this.onCopyToClipboard}
        //
        onCheckboxAppTxnClick={this.onCheckboxAppTxnClick}
        onCheckboxBankTxnClick={this.onCheckboxBankTxnClick}
        selectedAppTxnId={this.state.selectedAppTxnId}
        selectedBankTxnId={this.state.selectedBankTxnId}
        //
        onNachReconciliationClick={() => { this.setState({ nachReconciliationMode: true }) }}
        nachReconciliationMode={this.state.nachReconciliationMode}
        onCancelNachReconciliation={() => { this.setState({ nachReconciliationMode: false }) }}
        //
        iciciReconciliationMode={this.state.iciciReconciliationMode}
        onIciciReconciliationClick={() => { this.setState({ iciciReconciliationMode: true }) }}
        onIciciReconciliationCancel={() => { this.setState({ iciciReconciliationMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getTxns(context, this.props.match.params.accountNumber)
    this.getBankTxns(context, this.props.match.params.accountNumber)
  }

  componentDidUpdate(prevProps) {
    let context = this.props.context
    if (this.props.match.params.accountNumber === prevProps.match.params.accountNumber)
      return
    this.getTxns(context, this.props.match.params.accountNumber)
    this.getBankTxns(context, this.props.match.params.accountNumber)
  }

  onUpload = (fileId) => {
    RestApiUtils.post(this.props.context,
      `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankStatements/validation`,
      this.onUploadCallback, { fileId: fileId }
    )
  }

  onUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.ReconFailedBankTxns(this.props.match.params.accountNumber))
      this.getBankTxns(this.props.context, this.props.match.params.accountNumber)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onOtherUpload = (fileId) => {
    RestApiUtils.post(this.props.context,
      `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankStatements/validation/psv`,
      this.onOtherUploadCallback, { fileId: fileId }
    )
  }

  onOtherUploadCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
    })

    if (response.errorList.length === 0) {
      CacheManager.removeObject(CacheKeys.ReconFailedBankTxns(this.props.match.params.accountNumber))
      this.getBankTxns(this.props.context, this.props.match.params.accountNumber)
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
      }, 2000)
    }
  }

  onReconcileClick = () => {
    let reconcileSubmitted = this.state.reconcileSubmitted
    if (reconcileSubmitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      //reconcileSubmitted: true
    })

    {
      this.state.selectedBankTxnId && this.state.selectedAppTxnId &&
        this.setState({ reconcileSubmitted: true })
    }

    {
      this.state.selectedBankTxnId && this.state.selectedAppTxnId &&
        RestApiUtils.put(this.props.context,
          `/api/su/nodalBankAccounts/${this.props.match.params.accountNumber}/bankTransactions/reconciliations`,
          this.onReconcileClickCallback, {
          bankTransactionId: this.state.selectedBankTxnId,
          appTransactionId: this.state.selectedAppTxnId
        }
        )
    }
  }

  onReconcileClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      reconcileSubmitted: false
    })

    setTimeout(() => {
      this.setState({
        errorList: [],
        successMsg: null
      })
      if (response.errorList.length === 0)
        this.onRefreshClick()
    }, 2000)

  }

  onCheckboxAppTxnClick = (event) => {
    let appTxnId = event.currentTarget.getAttribute('data-id')
    this.setState({ selectedAppTxnId: appTxnId })
  }

  onCheckboxBankTxnClick = (event) => {
    let bankTxnId = event.currentTarget.getAttribute('data-id')
    this.setState({ selectedBankTxnId: bankTxnId })
  }

  getTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/transactions/reconcileFailed`,
      cacheKey: CacheKeys.ReconFailedTxns(accountNumber),
      callback: this.getTxnsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getTxnsCallback = (response) => {
    this.setState({ txnList: response.transactionList })
  }

  getBankTxns(context, accountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/nodalBankAccounts/${accountNumber}/bankTransactions/reconcileFailed`,
      cacheKey: CacheKeys.ReconFailedBankTxns(accountNumber),
      callback: this.getBankTxnsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getBankTxnsCallback = (response) => {
    this.setState({ bankTxnList: response.transactionList })
  }

  onCopyToClipboard = (text, result) => {
    this.setState({ copyToClipboardText: text })
    setTimeout(() => {
      this.setState({ copyToClipboardText: null })
    }, 3000)
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.ReconFailedTxns(this.props.match.params.accountNumber))
    CacheManager.removeObject(CacheKeys.ReconFailedBankTxns(this.props.match.params.accountNumber))
    this.setState({ txnList: null, bankTxnList: null }, () => {
      this.getTxns(context, this.props.match.params.accountNumber)
      this.getBankTxns(context, this.props.match.params.accountNumber)
    })
  }
}

export default withRouter(ReconciliationPageSF)
